import { Skeleton } from "../skeleton";

interface ChatListSkeletonProps {
  count?: number;
}

export function ChatListSkeleton({ count = 6 }: ChatListSkeletonProps) {
  return (
    <div className="space-y-3 sm:space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="w-full backdrop-blur-xl border rounded-2xl p-5 bg-white/70 border-slate-200/60  "
        >
          <div className="flex items-start gap-4">
            {/* Avatar */}
            <div className="relative shrink-0">
              <Skeleton className="w-14 h-14 rounded-xl" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              {/* Header Row */}
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2 min-w-0 flex-1">
                  {/* Name */}
                  <Skeleton className="h-[20px] w-[120px] rounded-[4px]" />
                  {/* Project Badge */}
                  <Skeleton className="h-[18px] w-[100px] rounded-[4px]" />
                </div>
                {/* Time & Badge */}
                <div className="flex items-center gap-2 shrink-0 ml-4">
                  <Skeleton className="h-[14px] w-[60px] rounded-[4px]" />
                  <Skeleton className="w-[22px] h-[22px] rounded-full" />
                </div>
              </div>

              {/* Last Message */}
              <div className="space-y-1.5">
                <Skeleton className="h-[16px] w-[90%] rounded-[4px]" />
                <Skeleton className="h-[16px] w-[60%] rounded-[4px]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

ChatListSkeleton.displayName = "ChatListSkeleton";
